import { type Socket, io } from 'socket.io-client'

let socket: Socket | null = null

export function getSocket(): Socket {
  if (socket) return socket
  socket = io({
    withCredentials: true,
    /**
     * websocket-first so we skip the long-polling handshake. the old
     * polling-then-upgrade default left a `transport=polling&sid=...` poll that
     * 400s ("unknown session id") whenever the session drops, on a refresh or
     * when the dev api restarts on save. tryAllTransports keeps polling as a
     * fallback for networks that block websockets.
     */
    transports: ['websocket', 'polling'],
    tryAllTransports: true,
    autoConnect: true
  })
  return socket
}

export function disconnectSocket(): void {
  if (!socket) return
  socket.disconnect()
  socket = null
}
